import { render, staticRenderFns } from "./teacherAvatarForm.vue?vue&type=template&id=11e35a00&scoped=true"
import script from "./teacherAvatarForm.vue?vue&type=script&lang=js"
export * from "./teacherAvatarForm.vue?vue&type=script&lang=js"
import style0 from "./teacherAvatarForm.vue?vue&type=style&index=0&id=11e35a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e35a00",
  null
  
)

export default component.exports